const READ_ARGUMENT_PATTERN = /"([^"]*)"|\[(@?[A-Z0-9_#]+)\]/g;

function stripTechnicalSuffix(variableName = '') {
  return variableName.replace(/#[A-Z]$/i, '');
}

function cleanReadSource(source = '') {
  return source.replace(/:$/, '');
}

function createReadDiagnostic(code, message) {
  return {
    level: 'warning',
    code,
    message,
  };
}

function normalizeReadInput(raw = '') {
  return raw.trim().replace(/^READ\b\s*/i, '');
}

function parseReadArguments(expression, columnMatch) {
  const literals = [];
  const variables = [];

  if (!columnMatch) {
    return {
      literals,
      variables,
      search: null,
      target: null,
      until: null,
    };
  }

  const tail = expression.slice(columnMatch.index + columnMatch[0].length);
  let match;
  let foundTarget = false;
  let search = null;
  let until = null;

  READ_ARGUMENT_PATTERN.lastIndex = 0;

  while ((match = READ_ARGUMENT_PATTERN.exec(tail)) !== null) {
    if (match[2]) {
      const variable = stripTechnicalSuffix(match[2]);
      variables.push(variable);

      if (!foundTarget) {
        foundTarget = true;
      }

      continue;
    }

    literals.push(match[1]);

    if (!foundTarget && search === null) {
      search = match[1];
      continue;
    }

    if (foundTarget && until === null) {
      until = match[1];
    }
  }

  return {
    literals,
    variables,
    search,
    target: variables[0] || null,
    until,
  };
}

export function parseReadInstruction(raw = '') {
  const expression = normalizeReadInput(raw);
  const sourceMatch = expression.match(/\bF\s*=\s*"([^"]*)"/i);
  const rowMatch = expression.match(/\bR\s*=\s*(\d+)/i);
  const columnMatch = expression.match(/\bC\s*=\s*(\d+)/i);
  const readArguments = parseReadArguments(expression, columnMatch);
  const diagnostics = [];

  if (!sourceMatch || !rowMatch || !columnMatch || !readArguments.target) {
    diagnostics.push(createReadDiagnostic('READ_PARSE_UNCERTAIN', 'READ no pudo interpretarse completamente'));
  }

  if (readArguments.variables.length > 1) {
    diagnostics.push(
      createReadDiagnostic('READ_MULTIPLE_TARGETS', 'READ contiene mas de una variable destino; se conservan en orden para revision.')
    );
  }

  const parseStatus = diagnostics.some((diagnostic) => diagnostic.code === 'READ_PARSE_UNCERTAIN') ? 'unknown' : 'parsed';

  return {
    type: 'read',
    source: sourceMatch ? cleanReadSource(sourceMatch[1]) : null,
    row: rowMatch ? Number(rowMatch[1]) : null,
    column: columnMatch ? Number(columnMatch[1]) : null,
    search: readArguments.search,
    target: readArguments.target,
    targets: readArguments.variables,
    variables: readArguments.variables,
    literals: readArguments.literals,
    until: readArguments.until,
    parseStatus,
    visible: false,
    raw,
    ...(diagnostics.length > 0
      ? {
          diagnostic: diagnostics[0],
          diagnostics,
        }
      : {}),
  };
}
